import React, { Component } from 'react';
import styled from 'styled-components';
import { verify_mobile } from '../utils/Utils';


export const ButtonArquivo = styled.div`
    background-color: #767676;
    color: white;
    font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
    font-weight: bold;
    padding: .78571429em 1.5em .78571429em;
    border-radius: .28571429rem;
    position: relative;
    margin-top: 16px;
    width: 98%;
    cursor: pointer;
    transition: opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease,-webkit-box-shadow .1s ease;

    :hover {
        background-color: #838383;
        cursor: pointer;
    }
`

export const ButtonArquivoDuvida = styled.div`
    background-color: #767676;
    color: white;
    
    font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
    font-weight: bold;
    
    position: relative;
    margin-top: ${ !verify_mobile() ?  "16px" : "-10px"};;
    width: ${ !verify_mobile() ?  "98%" : "228px"};

    display: flex;

    overflow: hidden;

    border-radius: .28571429rem;
    cursor: pointer;
    transition: opacity .1s ease, background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease,-webkit-box-shadow .1s ease;

    :hover {
        color: black;
        background-color: #838383;
        cursor: pointer;
    }
`